/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import {
	AiFillLinkedin,
	AiFillGithub,
	AiFillTwitterSquare
} from 'react-icons/ai';

import Header from "./header"
import "../styles/layout.css"


const Layout = ({ children }) => {
	const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

	return (
		<>
			<Header siteTitle={data.site.siteMetadata.title} />
			<div
				style={{
					margin: `0 auto`,
					padding: `0`,
				}}
			>
				<main>{children}</main>
			</div>
			<footer>
				<br /><br /><div className="footer-container">
					<small>Copyright © {new Date().getFullYear()} David Macharia Mwangi</small><br />
					<small className="footer-links">
						<a href="https://www.linkedin.com/in/david-mwangi-78622b174" target="_blank">
							<AiFillLinkedin className="footer-sm-links" />
						</a>
						<a href="https://github.com/dave-mash" target="_blank">
							<AiFillGithub className="footer-sm-links" />
						</a>
						<a href="https://twitter.com/theetechpriest_" target="_blank">
							<AiFillTwitterSquare className="footer-sm-links" />
						</a>
					</small>
				</div>
			</footer>
		</>
	)
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}

export default Layout
